module.exports = __webpack_public_path__ + "media/carta5.cbaa5de2.mp3";